export default class Tabs {
    static init(): void {
        this.baseTabs();
        this.reactGlobe();
    }

    static baseTabs(): void {
        const tabInitClass = document.querySelectorAll<HTMLDivElement>('.js-tabs-init');

        if (tabInitClass.length > 0) {
            tabInitClass.forEach(tabs => {
                // Vyber všechny taby a obsah s přesným typováním
                const tabNavItems = tabs.querySelectorAll<HTMLAnchorElement>('.tab-nav-item');
                const tabNavContents = tabs.querySelectorAll<HTMLDivElement>('.tab-content');

                if (tabNavItems.length > 0 && tabNavContents.length > 0) {
                    // Přidat event listener pro každý tab
                    tabNavItems.forEach(tab => {
                        tab.addEventListener('click', switchTab);
                    });
                }

                function switchTab(event: MouseEvent): void {
                    event.preventDefault();

                    // Odebrat aktivní třídu ze všech tabů
                    tabNavItems.forEach(tab => tab.classList.remove('is-active'));

                    // Přidat aktivní třídu na kliknutý tab
                    const clickedTab = event.currentTarget as HTMLAnchorElement;
                    clickedTab.classList.add('is-active');

                    // Získat název obsahu z atributu
                    const targetContent = clickedTab.getAttribute('data-tab-nav');

                    // Zobrazit pouze obsah odpovídající aktivnímu tabu
                    tabNavContents.forEach(content => {
                        if (content.getAttribute('data-tab-content') === targetContent) {
                            content.classList.add('is-active');
                        } else {
                            content.classList.remove('is-active');
                        }
                    });
                }
            });
        }
    }

    static reactGlobe(): void {
        const globeReactInit = document.querySelectorAll<HTMLDivElement>('.js-react-globe');

        if (globeReactInit.length > 0) {
            globeReactInit.forEach(globes => {
                // Vyber všechny taby a obsah s přesným typováním
                const globeNavItems = globes.querySelectorAll<HTMLAnchorElement>('.react-mobile-globe-item');
                const globeNavContents = globes.querySelectorAll<HTMLDivElement>('.react-mobile-content__inner');

                if (globeNavItems.length > 0 && globeNavContents.length > 0) {
                    // Přidat event listener pro každý tab
                    globeNavItems.forEach(item => {
                        item.addEventListener('click', switchItems);
                    });
                }

                function switchItems(event: MouseEvent): void {
                    event.preventDefault();

                    // Odebrat aktivní třídu ze všech tabů
                    globeNavItems.forEach(item => item.classList.remove('is-active'));

                    // Přidat aktivní třídu na kliknutý tab
                    const clickedTab = event.currentTarget as HTMLAnchorElement;
                    clickedTab.classList.add('is-active');

                    // Získat název obsahu z atributu
                    const targetContent = clickedTab.getAttribute('data-globe-nav');

                    // Zobrazit pouze obsah odpovídající aktivnímu tabu
                    globeNavContents.forEach(content => {
                        if (content.getAttribute('data-globe-content') === targetContent) {
                            content.classList.add('is-active');
                        } else {
                            content.classList.remove('is-active');
                        }
                    });
                }
            });
        }
    }
}
